export default "/images/vendor/flag-icon-css/flags/4x3/et.svg?c3d2d75ff7299b68bf189fa1ecb9380b";